import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    tabsIndex: 0,
    tabs: [{
        Aba: 0,
        Nome: "Home",
        Codigo: 0           // Codigo = ID da aba
    }],
    ultimaAbaAdicionada: 0,
    closedTabsHistory: []
};

const tabsSlice = createSlice({
    name: "tabs",
    initialState,
    reducers: {
        newTab: (state, action) => {
            const newTab = action.payload;
            
            const tabExists = state.tabs.some(tab => tab.Nome === newTab.Nome);
            if (tabExists) return;
            
            const newCodigo = state.tabs.length > 0 
                ? state.tabs[state.tabs.length - 1].Codigo + 1
                : 1;
            
            state.tabs.push({
                Aba: newTab.Aba || 0,
                Nome: newTab.Nome,
                Codigo: newCodigo
            });
            
            state.tabsIndex = newCodigo;
            state.ultimaAbaAdicionada = newCodigo;
        },
        
        closeTab: (state, action) => {
            const codigoToClose = action.payload;
            const tabIndex = state.tabs.findIndex(tab => tab.Codigo === codigoToClose);
            
            if (tabIndex === -1) return;
            
            state.closedTabsHistory.push(state.tabs[tabIndex]);
            
            state.tabs.splice(tabIndex, 1);
            
            if (state.tabs.length === 0) {
                state.tabs.push({
                    Aba: 0,
                    Nome: "Home",
                    Codigo: 0
                });
                state.tabsIndex = 0;
            } else if (state.tabsIndex === codigoToClose) {
                const newActiveIndex = Math.min(tabIndex, state.tabs.length - 1);
                state.tabsIndex = state.tabs[newActiveIndex].Codigo;
            }
        },
        
        changeTab: (state, action) => {
            const codigo = action.payload;
            const tabExists = state.tabs.some(tab => tab.Codigo === codigo);
            
            if (tabExists) {
                state.tabsIndex = codigo;
            } else {
                state.tabsIndex = 0;
            }
        },
        
        setTabFromNewIndex: (state, action) => {
            const abaIndex = action.payload;
            const tab = state.tabs.find(tab => tab.Aba === abaIndex);
            
            if (tab) {
                state.tabsIndex = tab.Codigo;
            }
        }
    }
});

export const { 
    closeTab, 
    changeTab, 
    newTab, 
    setTabFromNewIndex
} = tabsSlice.actions;

export default tabsSlice.reducer;